export default {
  getName(contact, showEmail=true){

    let name = ((contact.first_name==null || contact.first_name==='') && (contact.last_name==null || contact.last_name==='')) ? 'Unnamed contact' : (contact.first_name + " " + contact.last_name);

    if(showEmail){
        let email = contact.work_email!=null || contact.work_email!='' ? contact.work_email : contact.email;
        if(email!=null && email != ''){
          name= name + "("+email+")";
        }
    }

    return name;
  }
}
